import React, { useEffect, useState } from 'react'

import { FormattedMessage } from 'react-intl'
import ReactQuill from 'react-quill'
import Box from '@material-ui/core/Box'

import CollectionHandler from 'assets/CollectionHandler.js'
import TagMultiSelect from 'shared/components/TagMultiSelect/TagMultiSelect'
import FieldTitle from '../../components/FieldTitle/FieldTitle'
import FieldError from '../../components/FieldError/FieldError'
import FieldDivider from '../../components/FieldDivider/FieldDivider'
import { useStyles } from './CandidateForm_style'
import { useStyles as useSharedStyles } from '../../../FirstJobFunnel/FirstJobFunnel_style'
import { QUILL_MODULES } from '../../../settings'
import { Switch, Typography } from '@material-ui/core'

const CandidateForm = (props) => {
    const classes = useStyles()
    const sharedClasses = useSharedStyles()
    const { jobForm, errors, handleUpdate, handleAttributeChange, isAiGenerated } = props
    const studyDomainCollection = CollectionHandler.Get('studyDomainCollection')

    const handleSelectedItems = (selectedItems, attribute) => {
        const formattedItems = selectedItems.map(item => item.value)
        handleUpdate({ [attribute]: formattedItems })
    }

    return (
        <Box className={sharedClasses.formContainer}>
            <Box className={sharedClasses.formField}>
                <FieldTitle isOptional title={<FormattedMessage id="jobcreationfunnel.titles.study_level"/>}/>
                <Box display='flex' flexDirection='row'>
                    <Box className={classes.subTitle}>
                        <FormattedMessage id="jobcreationfunnel.titles.secundary_school_certificate">
                            {text => <Typography dangerouslySetInnerHTML={{ __html: text }} className={classes.subTitle}/>}
                        </FormattedMessage>
                    </Box>
                    <Switch
                        name='only_secundary_school'
                        classes={{ root: sharedClasses.iosSwitch }}
                        className={classes.toggleSwitch}
                        checked={!jobForm.candidateHigherEducationNeeded}
                        value={!jobForm.candidateHigherEducationNeeded}
                        onChange={() => handleAttributeChange('candidateHigherEducationNeeded', !jobForm.candidateHigherEducationNeeded)}
                    />
                </Box>
                <FieldDivider />
                <Box className={sharedClasses.flexBox}>
                    <FieldTitle title={<FormattedMessage id="jobcreationfunnel.titles.study_domains"/>}/>
                    {isAiGenerated && <Box className={sharedClasses.aiLabel}>
                        <FormattedMessage id="job_creation_funnel.job_offer_generator.ai_powered_label"/>
                    </Box>}
                </Box>
                <TagMultiSelect
                    collection={studyDomainCollection}
                    selectedItems={jobForm.candidateStudyDomains.map(studyDomain => ({ value: studyDomain }))}
                    setSelectedItems={(items) => handleSelectedItems(items, 'candidateStudyDomains')}
                    enableSelectAll={true}
                />
                <FieldError errorMessage={errors.candidateStudyDomains} />
                <FieldDivider />
            </Box>
            <Box className={sharedClasses.formField}>
                <Box className={sharedClasses.flexBox}>
                    <FieldTitle title={<FormattedMessage id="jobcreationfunnel.titles.searched_profile"/>}/>
                    {isAiGenerated && <Box className={sharedClasses.aiLabel}>
                        <FormattedMessage id="job_creation_funnel.job_offer_generator.ai_powered_label"/>
                    </Box>}
                </Box>
                <Box className={sharedClasses.quillStyling}>
                    <ReactQuill
                        modules={QUILL_MODULES}
                        value={jobForm.candidateSearchedProfile || ''}
                        name="candidateSearchedProfile"
                        onChange={(value) => handleAttributeChange('candidateSearchedProfile', value)}
                    />
                </Box>
                <FieldError errorMessage={errors.candidateSearchedProfile} />
            </Box>
        </Box>
    )
}

export default CandidateForm
